var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSkip = function SvgSkip(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.04 5.957c0 .552.451 1.004 1.003 1.004h4.016c.552 0 1.004-.452 1.004-1.004V1.94c0-.552-.452-1.004-1.004-1.004s-1.004.452-1.004 1.004v1.747A7.981 7.981 0 0 0 8.03.938 8.03 8.03 0 0 0 0 8.967c0 4.077 3.032 7.43 6.967 7.952.02 0 .04.01.06.01.332.04.663.07 1.004.07 1.763 0 2.008-.23 2.008-1.004s-.502-1.004-2.008-1.004c-.712 0-1.375-.15-2.007-.381v.01a5.988 5.988 0 0 1-4.016-5.652c0-3.323 2.7-6.024 6.023-6.024 1.777 0 3.373.783 4.478 2.008h-1.466c-.552 0-1.004.452-1.004 1.004Z",
    fill: "currentColor"
  })));
};
export default SvgSkip;